export default __webpack_public_path__ + "static/media/news-detail-2.4c5a5f93.png";